import styled, {css, DefaultTheme} from 'styled-components'
import {Menu, MenuGroup, MenuItem, MenuHeading} from '@ariakit/react'
import {CSSProperties} from 'react'
import {MenuVariant} from './MenuAtoms'

export const StyledMenu = styled(Menu)<{$width: CSSProperties['width']}>(
    ({theme: {palette, shadows, zIndex}, $width}) => css`
        background-color: ${palette.neutral['25']};
        border-radius: 8px;
        box-shadow: ${shadows.lg};
        border: 1px solid ${palette.neutral['200']};
        z-index: ${zIndex.dropdown};
        max-height: var(--popover-available-height);
        overflow-y: auto;
        ${!!$width &&
        css`
            width: ${$width};
        `};
    `
)

export const StyledMenuHeading = styled(MenuHeading)(
    ({theme: {spacing, palette, typography}}) => css`
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        color: ${palette.neutral['500']};
        ${typography.textSm};
    `
)

export const StyledMenuGroup = styled(MenuGroup)(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing}px;
        &:not(:last-child) {
            margin-bottom: ${spacing}px;
            border-bottom: 1px solid ${palette.neutral['200']};
        }
    `
)

const makeMenuItemVariantStyle = (theme: DefaultTheme) =>
    ({
        neutral: css`
            color: ${theme.palette.neutral['950']};
            & > svg {
                fill: ${theme.palette.neutral['500']};
            }
            &[aria-disabled='true'] {
                color: ${theme.palette.neutral['400']};
                & > svg {
                    fill: ${theme.palette.neutral['300']};
                }
            }
        `,
        danger: css`
            color: ${theme.palette.danger['500']};
            & > svg {
                fill: ${theme.palette.danger['500']};
            }
            &[aria-disabled='true'] {
                color: ${theme.palette.danger['300']};
                & > svg {
                    fill: ${theme.palette.danger['300']};
                }
            }
        `
    }) as const satisfies Record<MenuVariant, ReturnType<typeof css>>

export const StyledMenuItem = styled(MenuItem)<{$variant: 'neutral' | 'danger'}>(
    ({theme, $variant = 'neutral'}) => css`
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 1.5}px ${theme.spacing * 2}px;
        transition: ${theme.transition};
        ${theme.typography.textSm};
        & > svg {
            width: 16px;
            height: 16px;
        }

        ${makeMenuItemVariantStyle(theme)[$variant]};

        &:hover {
            background-color: ${theme.palette.neutral['100']};
        }

        &[aria-disabled='true'] {
            cursor: not-allowed;
            color: ${theme.palette.neutral['400']};
            & > svg {
                fill: ${theme.palette.neutral['300']};
            }
        }
    `
)
